import React, { useEffect, useState } from "react";
import { API, graphqlOperation, Auth, Storage } from "aws-amplify";
import { useParams } from "react-router-dom";
import "./Home.scss";
import Modal from 'react-modal';

import {
    listVideos,
    listCategories,
    listTags,
    listVideoTags,
    listTeachers,
    getCourse,
    courseModulesByCourseID,
    getModule,
    listVideoURLs
} from "../graphql/queries";

import { createTag } from "../graphql/mutations";

// Component Imports
import FilterBar from "../components/FilterBar";
import TagBar from "../components/TagBar";
import VideoGrid from "../components/VideoGrid";
import useFavorites from "../FavoritesUtils";
//import CognitoData from "../components/CognitoData";
import FilterSideBar from "../components/FilterSideBar";
import TermsCheck from "../components/TermsCheck";
import CourseBannerLayout from '../components/CourseBannerLayout';
import CourseModalManager from '../components/CourseModalManager';
import AccessDeniedModal from "../components/AccessDeniedModal";

Modal.setAppElement('#root');

const Home = ({ 
    isOpen, 
    handleToggle, 
    isJourneyModalOpen, 
    setIsJourneyModalOpen,
    activeCourseKey,
    setActiveCourseKey,
    searchQuery,
    onSearchClear
}) => {
    const { videoId } = useParams();
    const [playId, setPlayId] = useState(null);
    const [tempUUID, setTempUUID] = useState(null);
    const storedTempUUID = localStorage.getItem("tempUUID");
    const [videos, setVideos] = useState([]);
    const [categories, setCategories] = useState([]);
    const [tags, setTags] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState({
        category: [], 
        duration: [], 
        teacher: [], 
    });
    const { favorites, toggleFavorite } = useFavorites();
    const [selectedTags, setSelectedTags] = useState([]);
    const [videoTags, setVideoTags] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [instructors, setInstructors] = useState([]);

    const [filteredVideos, setFilteredVideos] = useState([]);
    const [isLoadingVideos, setIsLoadingVideos] = useState(true);
    
    const [username, setUsername] = useState(null); 
    const [showAccessDeniedModal, setShowAccessDeniedModal] = useState(false);

    useEffect(() => {
        if (storedTempUUID) {
            setTempUUID(storedTempUUID);
            setPlayId(storedTempUUID);
            localStorage.removeItem("tempUUID");
        } else {
            setPlayId(videoId);
        }
    }, [storedTempUUID, videoId]);

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const videosResponse = await API.graphql(
                    graphqlOperation(listVideos, { limit: 10000 })
                );
                const videosData = videosResponse.data.listVideos.items;
                setVideos(videosData);
                setIsLoadingVideos(false);
            } catch (error) {
                console.error("Error fetching initial data:", error);
                setIsLoadingVideos(false);
            }
        };

        fetchInitialData();
    }, []);

    const getUserInfo = async () => {
        try {
            const user = await Auth.currentAuthenticatedUser();
            //const token = user.signInUserSession.idToken.jwtToken; // This can vary based on your specific setup
            //console.log(token);
            // Now you can use the token to make a request to your Lambda function
            setUsername(user.username);
            //console.log("auth username: ", user.username);
        } catch (error) {
            console.error("Error fetching user info:", error);
        }
    };

    useEffect(() => {

        getUserInfo();

        const fetchCategories = async () => {
            try {
                const categoriesResponse = await API.graphql(
                    graphqlOperation(listCategories, { limit: 10000 })
                );
                const categoriesData =
                    categoriesResponse.data.listCategories.items;
                setCategories(categoriesData);
            } catch (error) {
                console.log("Error fetching categories:", error);
            }
        };

        const fetchTags = async () => {
            try {
                const tagsResponse = await API.graphql(
                    graphqlOperation(listTags, { limit: 10000 })
                );
                const tagsData = tagsResponse.data.listTags.items;

                // Sort the tags array by name before setting it to state
                const sortedTagsData = tagsData.sort((a, b) =>
                    a.name.localeCompare(b.name)
                );

                setTags(sortedTagsData);
            } catch (error) {
                console.log("Error fetching tags:", error);
            }
        };

        const fetchVideoTags = async () => {
            try {
                const videoTagsResponse = await API.graphql(
                    graphqlOperation(listVideoTags, { limit: 10000 })
                );
                const videoTagsData =
                    videoTagsResponse.data.listVideoTags.items;
                setVideoTags(videoTagsData);
                //console.log(videoTagsData);
                //console.log(videoTagsData[0].tag.id);
            } catch (error) {
                console.log("Error fetching video tags:", error);
            }
        };
        // Fetch instructor data
        const fetchInstructors = async () => {
            try {
                const instructorsResponse = await API.graphql(
                    graphqlOperation(listTeachers, { limit: 10000 })
                );
                const instructorsData =
                    instructorsResponse.data.listTeachers.items;
                setInstructors(instructorsData);
            } catch (error) {
                console.log("Error fetching instructors:", error);
            }
        };

        // Removed fetchJourneyCourse - now handled by CourseModalManager

        fetchCategories();
        fetchTags();
        fetchVideoTags();
        fetchInstructors();
    }, []);

    const handleFilterSelect = (filters) => {
        //console.log("selected filters", filters);
        setSelectedFilters(filters);
    };

    const handleTagSelect = (selectedTags) => {
        setSelectedTags(selectedTags);
    };

    const filters = categories.map((category) => ({
        id: category.id,
        name: category.name,
    }));

    //const tagNames = tags.map((tag) => tag.name);

    const handleFavoriteToggle = (videoId, isFavorite) => {
        toggleFavorite(videoId, isFavorite);
    };

    //const [isOpen, setIsOpen] = useState(true);

    //const handleToggle = () => {
    //  setIsOpen((prevIsOpen) => !prevIsOpen);
    //};
    /*
    useEffect(() => {
        const handleResize = () => {
            // Check the current viewport width
            const width = window.innerWidth;

            // If the viewport width is less than 1000px, close the sidebar by default
            if (width < 1000) {
                //setIsOpen(false);
                handleToggle();
            } else {
                //setIsOpen(true);
                handleToggle();
            }
        };
        // Immediately call handleResize to set the correct state on initial render
        handleResize();

        // Add the event listener
        window.addEventListener("resize", handleResize);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
*/

    const handleCourseClick = async (courseKey) => {
        try {
            const user = await Auth.currentAuthenticatedUser({
                bypassCache: true,
            });
            const token = user.signInUserSession.idToken.jwtToken;

            const myInit = {
                headers: {
                    Authorization: token,
                },
            };

            const response = await API.get(
                "bbwvideoauthapi",
                "/videoaccess",
                myInit
            );

            if (response !== "Access granted") {
                setShowAccessDeniedModal(true);
                return;
            }

            // Set the active course and open modal
            setActiveCourseKey(courseKey);
            setIsJourneyModalOpen(true);
        } catch (error) {
            console.error("Error checking course access:", error);
            setShowAccessDeniedModal(true);
        }
    };

    return (
        <>
            <div className={`home-container ${isJourneyModalOpen ? 'modal-open' : ''}`}>
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "0px 1fr",
                        gap: "0",
                        transition: "all 0.3s ease-in-out",
                    }}
                >
                    <div
                        className={`filter-sidebar-component ${isOpen ? "open" : "closed"}`}
                        style={{
                            marginTop: "72px",
                        }}
                    >
                        <FilterSideBar
                            isOpen={isOpen}
                            handleToggle={handleToggle}
                            filters={filters}
                            selectedFilters={selectedFilters}
                            onFilterSelect={handleFilterSelect}
                            tags={tags}
                            selectedTags={selectedTags}
                            onTagSelect={handleTagSelect}
                            instructors={instructors}
                            favoritesActive={selectedFilters.favorites}
                            favorites={favorites}
                            isHidden={isJourneyModalOpen}
                            onCourseClick={handleCourseClick}
                            onSearchClear={onSearchClear}
                        />
                    </div>
                    <div
                        className="video-grid-component"
                        style={{
                            marginTop: "72px",
                            /*width: "100%",
                            transition: "all 0.3s ease-in-out",
                            marginLeft: isOpen ? "300px" : "0px",
                            paddingLeft: "0px"*/
                        }}
                    >
                        {/* Course Banners */}
                        <CourseBannerLayout
                            onCourseClick={handleCourseClick}
                            isOpen={isOpen}
                        />
                        <VideoGrid
                            videos={videos}
                            isLoadingVideos={isLoadingVideos}
                            filters={selectedFilters}
                            favorites={favorites}
                            videoTags={videoTags}
                            tags={tags}
                            videoId={playId}
                            onFavoriteToggle={handleFavoriteToggle}
                            toggleFavorites={toggleFavorite}
                            selectedTags={selectedTags}
                            instructors={instructors}
                            isOpen={isOpen}
                            isJourneyModalOpen={isJourneyModalOpen}
                            searchQuery={searchQuery}
                        />
                    </div>
                </div>
            </div>

            <CourseModalManager
                activeCourseKey={activeCourseKey}
                isOpen={isJourneyModalOpen}
                onRequestClose={() => {
                    setIsJourneyModalOpen(false);
                    setActiveCourseKey(null);
                }}
                favorites={favorites}
                onFavoriteToggle={handleFavoriteToggle}
                instructors={instructors}
            />

            {showAccessDeniedModal && (
                <AccessDeniedModal
                    onClose={() => setShowAccessDeniedModal(false)}
                />
            )}
        </>
    );
};

export default Home;
